type Args = {
  authFullDisplayName: string;
  enteredFirstName: string;
  enteredLastName: string;
};

export const normalizeAuthName = (
  data: Args
): {
  firstName: string;
  lastName: string;
} => {
  const { authFullDisplayName, enteredFirstName, enteredLastName } = data;

  const authFirstName = authFullDisplayName?.split(' ')?.[0] || 'Unknown';
  const authLastName = authFullDisplayName?.split(' ')?.[1] || 'Unknown';

  return {
    firstName: enteredFirstName || authFirstName,
    lastName: enteredLastName || authLastName,
  };
};
